import { useEffect, useMemo, useRef } from 'react';
import { IModalRefProps } from 'ui/components/Modals/Modal/types';

import { PAGES } from '~/constants/pages.constants';
import { useAppSelector } from '~/hooks/useAppSelector';
import { useRouter } from '~/hooks/useRouter';

export const useEnablePreferencesModal = () => {
  const {
    user,
    isLoading: isUserLoading,
    selectedUserProfile,
  } = useAppSelector(({ auth }) => auth);
  const { goToRoute, location } = useRouter();

  const modalRef = useRef<IModalRefProps>(null);

  const onClose = () => {
    modalRef.current?.close();
  };

  const handleOpen = () => {
    modalRef.current?.open();
  };

  const onPressButton = () => {
    onClose();
    goToRoute(PAGES.Profile);
  };

  const organizationHasExternalId = useMemo(() => {
    const organization = selectedUserProfile?.ecosystemSummary?.organization;
    if (!organization || typeof organization === 'string') return false;
    return !!organization.organizationSettings?.hasExternalId;
  }, [selectedUserProfile?.ecosystemSummary?.organization]);

  useEffect(() => {
    if (isUserLoading) return;

    const isOnProfilePage = location.pathname === PAGES.Profile;
    if (isOnProfilePage) return;

    const hasIncompletePreferences =
      !user?.preferences?.skills?.length || !user?.preferences?.address;

    const needsExternalId =
      organizationHasExternalId && !selectedUserProfile?.externalId;

    if (hasIncompletePreferences || needsExternalId) {
      handleOpen();
    }
  }, [
    user,
    user?.preferences?.skills,
    user?.preferences?.address,
    isUserLoading,
    organizationHasExternalId,
    selectedUserProfile?.externalId,
    location.pathname,
  ]);

  return { modalRef, onPressButton };
};
